import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const AumComponent = lazy(() =>
  import("@/modules/insights/pages/aum").then((module) => ({
    default: module.AumTab,
  }))
);

export const Route = createFileRoute("/(auth)/_headed/insights/_layout/aum")({
  component: AumComponent,
});
